import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
export const diamondCongrats = {
    version: 1,
    themeId: "diamond-congrats",
    name: "Argyle",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/diamond-congrats.webp`,
    background: [
        {
            variant: "diamonds",
            urls: [
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/diamond-congrats/square-bg-tile-5.png`,
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/diamond-congrats/bracket-bg-tile.png`,
            ],
            style: {
                opacity: 0.2,
            },
        },
    ],
    scenes: [
        {
            type: "generalSolidIntro",
            transitionVariant: "vertical-mask",
            durationSeconds: 5,
            faceCollage: {
                variant: "top-bottom-static",
                startAtSeconds: 1,
                entrance: {
                    variant: "diamond-mask",
                    transitionDurationInFrames: 10,
                },
            },
            title: {
                fontFamily: "Besley",
                fontSize: 140,
                fontWeight: "extralight",
                letterSpacing: "widest",
            },
            sceneBackground: {
                variant: "insetBox",
                padding: "0",
                entranceVariant: "diamonds",
                entranceFrom: 0,
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: {
                variant: "insetBox",
                padding: "0",
            },
        },
        {
            type: "clip-series-basic",
            showLogo: true,
            sceneBackground: {
                variant: "insetBox",
                padding: "0",
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: {
                variant: "insetBox",
                padding: "0",
            },
            // We need to slightly adjust the exit transition so the
            // following scene doesn't continue to be masked
            exitTransition: {
                variant: "diamondMask",
                customProps: { maskNextScene: false },
                timing: {
                    variant: "linear",
                    durationSeconds: 1,
                    easing: "easeOut",
                },
            },
        },
        {
            type: "outro",
            colorVariant: "lightBlue",
            entranceVariant: "scale-in",
            sceneBackground: {
                variant: "insetBox",
                padding: "0",
                entranceVariant: "diamonds",
                entranceFrom: 0,
            },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "",
            fontFamily: "Oswald",
            fontWeight: "light",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#000000",
                        backgroundOpacity: 0.75,
                    },
                ],
            },
            betweenTransition: {
                variant: "diamondMask",
                timing: {
                    variant: "linear",
                    durationSeconds: 1,
                    easing: "easeOut",
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#AB977B",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#AB977B",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 1,
            borderRadius: "0rem",
            boxShadow: "none",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "diamondMask",
            timing: {
                variant: "linear",
                durationSeconds: 1,
                easing: "easeOut",
            },
        },
    },
    userInputFields: [
        {
            id: "colorPicker",
            type: "colorPicker",
            label: "Color",
            defaultValue: "Forest",
        },
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Congrats, Emily! 🎉",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 50,
            },
        },
    ],
    colorPalettes: ["Forest", "Teal", "Blue", "Maroon", "Aurum", "Gray"],
};
